// Custom Collection Select Functionality
function toggleCustomSelect(header) {
  const select = header.closest('.custom-select');
  const options = select.querySelector('.custom-select__options');
  const isOpen = options.style.display === 'block';
  
  // Close all other selects
  document.querySelectorAll('.custom-select__options').forEach(opt => {
    opt.style.display = 'none';
  });
  document.querySelectorAll('.custom-select__header').forEach(h => {
    h.classList.remove('custom-select__header--open');
  });
  
  // Toggle current select
  if (!isOpen) {
    options.style.display = 'block';
    header.classList.add('custom-select__header--open');
  }
}

function selectOption(button, value) {
  const select = button.closest('.custom-select');
  const header = select.querySelector('.custom-select__header');
  const selectedText = select.querySelector('.custom-select__selected');
  const hiddenSelect = select.querySelector('.select__select');
  
  // Update display
  selectedText.textContent = button.textContent;
  
  // Update hidden select
  hiddenSelect.value = value;
  
  // Remove selected class from all options
  select.querySelectorAll('.custom-select__option').forEach(opt => {
    opt.classList.remove('custom-select__option--selected');
  });
  
  // Add selected class to clicked option
  button.classList.add('custom-select__option--selected');
  
  // Close dropdown
  const options = select.querySelector('.custom-select__options');
  options.style.display = 'none';
  header.classList.remove('custom-select__header--open');
  
  // Trigger form submission
  const form = select.closest('form');
  if (form) {
    form.submit();
  }
}

// Close dropdown when clicking outside
document.addEventListener('click', function(event) {
  if (!event.target.closest('.custom-select')) {
    document.querySelectorAll('.custom-select__options').forEach(opt => {
      opt.style.display = 'none';
    });
    document.querySelectorAll('.custom-select__header').forEach(h => {
      h.classList.remove('custom-select__header--open');
    });
  }
});

// Mobile facets checkbox state management
document.addEventListener('change', function(event) {
  if (event.target.matches('.mobile-facets__checkbox')) {
    const label = event.target.closest('.mobile-facets__label');
    if (label) {
      if (event.target.checked) {
        label.classList.add('active');
      } else {
        label.classList.remove('active');
      }
    }
  }
});

// Initialize mobile facets checkbox states on page load
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.mobile-facets__checkbox').forEach(function(checkbox) {
    const label = checkbox.closest('.mobile-facets__label');
    if (label && checkbox.checked) {
      label.classList.add('active');
    }
  });
});